<!-- Иконка разворачивания и сворачивания карты. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    <template v-if="variant === 'collapse'">
      <path d="M3 9H9V3M3 3L10 10M21 15H15V21M21 21L14 14" :stroke="stroke" stroke-width="2" />
    </template>
    <template v-else>
      <path d="M3 9V3H9M3 3L10 10M21 15V21H15M21 21L14 14" :stroke="stroke" stroke-width="2" />
    </template>
  </svg>
</template>

<script>
export default {
  name: "MapFullscreenIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
    variant: { type: String, default: "expand" },
  },
};
</script>
